import type { AssistantReq, AssistantRes } from '@/models/interface/aiAssistant';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

const baseUrl: string = import.meta.env.VITE_FUNDAY_CHATBOTTALK_BASE_URL;

export class AiAssistantService extends ApiFactory {
  constructor() {
    super(`${baseUrl}/Prompts`);
  }

  fetchAssistant(params: AssistantReq): Promise<ApiDataResponse<AssistantRes>> {
    return super.post('Assistant', params, {
      headers: {
        disableGlobalLoading: true
      }
    });
  }

  textToSpeech(params: { text: string }): Promise<ApiDataResponse<string>> {
    return super.post('TextToSpeech', `'${params.text}'`, {
      headers: {
        disableGlobalLoading: true,
        'Content-Type': 'application/json'
      }
    });
  }

  audioToText(params: { file: Blob }, language: number): Promise<ApiDataResponse<string>> {
    return super.post(`AudioToText/${language}`, params, {
      headers: {
        disableGlobalLoading: true,
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  speak(params: string): Promise<{ data: ReadableStream }> {
    return super.post('Speak', params, {
      headers: {
        disableGlobalLoading: true,
        'Content-Type': 'application/json'
      },
      adapter: 'fetch',
      responseType: 'stream'
    });
  }
}
